import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../App.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {getLeadership, getMentorship} from './updatables';
import TeachingTable from './teachingTable';
import { useMediaQuery } from 'react-responsive';

const TeachingAndService = ({page}) => {
    const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    const [leadership, setLeadership] = React.useState([]);
    const [mentorship, setMentorship] = React.useState([]);

    React.useEffect(() => {
        async function loadLeadership() {
            const data = await getLeadership();
            setLeadership(data);
        }

        loadLeadership();
    }, []);

    React.useEffect(() => {
        async function loadMentorship() {
            const data = await getMentorship();
            setMentorship(data);
        }

        loadMentorship();
    }, []);

    return <div style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between"}}>
      <div id="page" style={{marginLeft: isSmallScreen ? "-8%" : "0px", fontSize: isSmallScreen ? "30px" : "40px"}}>
        <Link to="/">
        </Link>
        {page}
      </div>
      <div className="tree" style={{marginLeft: isSmallScreen ? "4%" : "24px"}}>
        <ul>
          <li>
            <a style={{cursor: "default"}}>
                <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\teaching</h1>
                <TeachingTable />
            </a>
          </li>
          <li>
            <a style={{cursor: "default"}}>
                <h1 style={{fontSize: isSmallScreen ? "14px" : "28px"}}>\service</h1>
                <li>
                    <a style={{cursor: "default"}}>
                        <h2 style={{fontSize: isSmallScreen ? "12px" : "22px"}}>\leadership</h2>
                        <TableContainer style={{marginLeft: isSmallScreen ? "0%" : "32px"}}>
                            <Table sx={{ width: isSmallScreen ? "200%" : "90%", tableLayout: "fixed",
                            "& .MuiTableCell-head": {
                                fontFamily: "mainFont",
                                fontWeight: 700,
                                color: "#7c7788",
                                fontSize: isSmallScreen ? "8px" : "14px"
                                },
                                "& .MuiTableCell-body": {
                                fontFamily: "mainFont",
                                color: "#7c7788",
                                fontSize: isSmallScreen ? "8px" : "14px"
                                },
                            }} size="small">
                                <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: "35%"}}>Position</TableCell>
                                    <TableCell sx={{width: "45%"}}>Affiliation</TableCell>
                                    <TableCell sx={{width: "20%"}}>Duration</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {leadership.map((row) => (
                                    <TableRow
                                    key={row.role}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 },
                                    transition: "background-color 0.2s ease",
                                    "&:hover": {
                                    backgroundColor: "#F0B6D520",
                                    }, }}
                                    >
                                    <TableCell component="th" scope="row" style={{fontFamily: "mainFontItalic"}}>
                                        {row.role}
                                    </TableCell>
                                    <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.location}</TableCell>
                                    <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.terms}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </a>
                </li>
                <li>
                    <a style={{cursor: "default"}}>
                        <h2 style={{fontSize: isSmallScreen ? "12px" : "22px"}}>\mentorship</h2>
                        <TableContainer style={{marginLeft: isSmallScreen ? "0%" : "32px"}}>
                            <Table sx={{ width: isSmallScreen ? "200%" : "90%", tableLayout: "fixed",
                            "& .MuiTableCell-head": {
                                fontFamily: "mainFont",
                                fontWeight: 700,
                                color: "#7c7788",
                                fontSize: isSmallScreen ? "8px" : "14px"
                                },
                                "& .MuiTableCell-body": {
                                fontFamily: "mainFont",
                                color: "#7c7788",
                                fontSize: isSmallScreen ? "8px" : "14px"
                                },
                            }} size="small">
                                <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: "35%"}}>Position</TableCell>
                                    <TableCell sx={{width: "45%"}}>Affiliation</TableCell>
                                    <TableCell sx={{width: "20%"}}>Duration</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {mentorship.map((row) => (
                                    <TableRow
                                    key={row.role}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 },
                                    transition: "background-color .3s ease",
                                    "&:hover": {
                                    backgroundColor: "#F0B6D520",
                                    }, }}
                                    >
                                    <TableCell component="th" scope="row" style={{fontFamily: "mainFontItalic"}}>
                                        {row.role}
                                    </TableCell>
                                    <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.location}</TableCell>
                                    <TableCell align="left" style={{fontFamily: "mainFontPar"}}>{row.terms}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </a>
                </li>
            </a>
          </li>
        </ul>
      </div>
    </div>;
};

export default TeachingAndService;